import { themeDefinition } from 'common/components/Theme'

export const deviceBreakpoints = {
  mobileMaxWidth: themeDefinition.breakpoints.values.md - 1,
  desktopMinWidth: themeDefinition.breakpoints.values.md
}
